<template>
  <div class="user-info-modify-page">
      <div slot="header" class="card-header">
        <h2>用户信息修改</h2>
      </div>
      <div class="page-content">
        <!-- 用户信息修改表单 -->
        <div class="user-info-form-container">
          <div class="user-info-form-card">
            <h2 class="form-title">注册人信息修改</h2>
            <el-form :model="userInfoForm" :rules="userInfoRules" ref="userInfoForm" class="user-info-form">
              <el-form-item label="姓名" prop="name" class="form-item">
                <el-input 
                  v-model="userInfoForm.name" 
                  placeholder="请输入姓名"
                  class="user-info-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="手机号" prop="phone" class="form-item">
                <el-input 
                  v-model="userInfoForm.phone" 
                  placeholder="请输入手机号"
                  class="user-info-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="邮箱" prop="email" class="form-item">
                <el-input 
                  v-model="userInfoForm.email" 
                  placeholder="请输入邮箱"
                  class="user-info-input">·
                </el-input>
              </el-form-item>
              
              <el-form-item label="身份证号" prop="idCard" class="form-item">
                <el-input 
                  v-model="userInfoForm.idCard" 
                  placeholder="请输入身份证号"
                  class="user-info-input">
                </el-input>
              </el-form-item>
              
              <div class="form-actions">
                <el-button type="primary" class="modify-btn" @click="handleSubmit">修改</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoModify',
  data() {
    return {
      userInfoForm: {
        name: '',
        phone: '',
        email: '',
        idCard: ''
      },
      userInfoRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.userInfoForm.validate((valid) => {
        if (valid) {
          this.$message.success('用户信息修改成功')
          // 这里可以添加提交逻辑
        } else {
          this.$message.error('请检查输入信息')
        }
      })
    }
  }
}
</script>

<style scoped>
.user-info-modify-page {
  padding: 0;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-header {
  display: none;
}

.page-content {
  padding: 0;
}

/* 用户信息表单容器 */
.user-info-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 100%;
  overflow: hidden;
}

.user-info-form-card {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.form-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.user-info-form {
  width: 100%;
}
.form-actions {
  text-align: center;
  margin-top: 30px;
}

.modify-btn {
  width: 100%;
  height: 40px;
  background-color: #8e44ad;
  border-color: #8e44ad;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  transition: all 0.3s;
}

.modify-btn:hover {
  background-color: #9b59b6;
  border-color: #9b59b6;
}

.modify-btn:active {
  background-color: #7d3c98;
  border-color: #7d3c98;
}

.el-form .el-form-item {
    border: none; /* 去掉边框 */
}
.el-form {
    border: none; /* 去掉边框 */
}


</style>
